<p-table
    #dt
    [value]="listHistory$ | async"
    [rowHover]="true"
    dataKey="createdAt"
    selectionMode="single"
    [(selection)]="historySelected"
    [rows]="(pagination$ | async)?.per_page"
    [globalFilterFields]="table.globalFilterFields"
    [scrollable]="true"
    responsiveLayout="scroll"
    scrollable="true"
    scrollHeight="800px"
    width="100%"
    class="responsive-claims-table"
>
    <ng-template pTemplate="caption">
        <div class="d-flex justify-content-between flex-wrap align-items-start">
            <app-table-title
                [count]="(pagination$ | async)?.total"
                [perPage]="(pagination$ | async)?.per_page"
                [page]="(pagination$ | async)?.current_page"
                [totalPage]="(pagination$ | async)?.last_page"
            >
            </app-table-title>
            <div
                class="d-flex gap-2 align-items-center custom-header-actions mt-2 mt-md-0"
            >
                <app-table-button-header
                    (refresh)="pageCallback()"
                    (export)="onExportExcel()"
                    [disabledButtonExport]="
                        (listHistory$ | async)?.length === 0
                    "
                    [hiddenButtonOther]="true"
                >
                </app-table-button-header>
                <div>
                    <app-search-table [dt]="dt"></app-search-table>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th
                *ngFor="let col of table.cols"
                [class]="col.class"
                [ngStyle]="{
                    minWidth: col.width,
                    width: col.width,
                    textAlign: 'center'
                }"
            >
                <ng-container [ngSwitch]="col.header">
                    <ng-container *ngSwitchCase="'Date / Heure'">
                        {{ 'DATE_TIME' | translate }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'Operation'">
                        {{ 'OPERATION' | translate }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'Détails Operation'">
                        {{ 'DETAILS' | translate }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'Source [Utilisateur]'">
                        {{ 'SOURCE' | translate }}&nbsp;[{{
                            'USER' | translate
                        }}]
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{ col.header }}
                    </ng-container>
                </ng-container>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
        <tr [pSelectableRow]="item">
            <td
                *ngFor="let col of table.cols"
                [class]="col.class"
                [ngStyle]="{
                    minWidth: col.width,
                    width: col.width,
                    maxWidth: col.width
                }"
                [attr.data-label]="col.header"
            >
                <ng-container [ngSwitch]="col.header">
                    <ng-container *ngSwitchCase="'#'">
                        {{
                            ((pagination$ | async)?.current_page - 1) *
                                (pagination$ | async)?.per_page +
                                rowIndex +
                                1
                        }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'Actions'">
                        <button
                            pButton
                            pRipple
                            class="p-button-dark"
                            icon="pi pi-eye"
                            (click)="
                                handleAction({
                                    data: item,
                                    action: 'view-history',
                                    view: 'modal'
                                })
                            "
                        ></button>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{item?.[col.field]}}
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr *ngIf="(listHistory$ | async)?.length <= 0 && !spinner">
            <td class="posRelative" colspan="15">
                <span class="posCenter">
                    {{ 'NO_DATA_FOUND' | translate }}
                </span>
            </td>
        </tr>
        <tr *ngIf="spinner">
            <td class="posRelative" colspan="15">
                <p-progressSpinner
                    class="posCenter"
                    [style]="{ width: '40px', height: '50px' }"
                    styleClass="custom-spinner"
                    strokeWidth="8"
                    fill="#EEEEEE"
                    animationDuration=".5s"
                >
                </p-progressSpinner>
            </td>
        </tr>
    </ng-template>
</p-table>
<p-dialog
    header="[{{ 'HISTORY' | translate }}] [{{ historySelected?.source }}]"
    [(visible)]="visibleDetailsHistory"
    (onHide)="hideDialog()"
    [modal]="true"
    [closable]="true"
    [style]="{ width: '100%', 'min-height': '100%' }"
    [responsive]="true"
    [maximizable]="true"
    [draggable]="false"
    [resizable]="true"
>
    <ng-template pTemplate="content">
        <app-details-history
            [historySelected]="historySelected"
            (visibleDetailsHistory)="hideDialog()"
            [idModel]="idModel"
            [typeModel]="typeModel"
        >
        </app-details-history>
    </ng-template>
</p-dialog>
